import React from 'react';

import classes from './TodaysPlanCard.module.css';
import Button from '../../UI/Button/Button';
import ShowLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';


const TodaysPlanCard = (props) => {

    let itemCount = 0;

    let liveSessionsList = [];

    const startedBy = GetFromLocalStorage("username");

    const allTopicsList = !IsObjectEmpty(props.data.todaysPlan) && !IsListEmpty(props.data.todaysPlan.allTopicsList)
        ? props.data.todaysPlan.allTopicsList.map((topicItem, index) => {
            let updatedTopic = null;
            if (!IsObjectEmpty(topicItem)) {
                if (topicItem.type === 'topic') {
                    updatedTopic = (
                        <h5 className={classes.TopicHeading} key={index} onClick={() => props.onTodaysPlanTopicClicked(topicItem.topicId)}>{topicItem.topicName}</h5>
                    )
                }
                else if (topicItem.type === 'daily' || topicItem.type === 'new daily' || topicItem.type === 'weekly') {
                    updatedTopic = (
                        <p className={classes.PlanEntity} key={index} onClick={() => props.onTodaysPlanTopicClicked(topicItem.topicId)}>
                            {topicItem.type === 'daily' || topicItem.type === 'new daily' ? 'Daily Feedback' : 'Weekly Feedback'}
                            <span>opens at {topicItem.scheduleTime}</span>
                        </p>
                    )
                }
                else if (topicItem.type === 'live') {
                    let liveSessionTopic = (
                        <div key={index} className={classes.LiveSessionButtonContainer}>
                            <p className={classes.TopicHeading} onClick={() => props.onTodaysPlanTopicClicked(topicItem.topicId)}>{topicItem.topicName}</p>
                            <div>
                                {/* {!topicItem.sessionEnded
                                    ? <Button
                                        label='JOIN LIVE SESSION'
                                        fontSize="0.75em"
                                        clicked={!topicItem.started ? null : () => props.showLiveSessionPopup(topicItem.liveSessionId)}
                                        disabled={!topicItem.started}
                                        styleclass=""
                                        margin="0em 0px 0px 0px"
                                        padding="8px 24px"
                                    /> : null}
                                {topicItem.sessionEnded ? null : <br />}
                                {topicItem.sessionEnded
                                    ? <span className={[classes.BeginsText, classes.EndedText].join(' ')}>Live Session has ended</span>
                                    : !topicItem.started
                                        ? <span className={classes.BeginsText}>
                                            BEGINS AT&nbsp;{!IsStringEmpty(topicItem.scheduleTime) ? topicItem.scheduleTime : ''}
                                        </span>
                                        : <span className={classes.BeginsText}>Live Session is Started at {!IsStringEmpty(topicItem.scheduleTime) ? topicItem.scheduleTime : ''}</span>
                                } */}
                                {
                                    props.showLiveSessionLoader
                                        ? <div className={classes.MiniLoaderContainer}>
                                            <ShowLoader isLoading={true} transparentBg={true} />
                                        </div>
                                        : !topicItem.sessionEnded && !props.liveSessionEndedManually
                                            ? <>
                                                <Button
                                                    label={!IsStringEmpty(topicItem.startURL) ? 'JOIN LIVE SESSION' : 'START LIVE SESSION'}
                                                    padding="1em 2em"
                                                    margin="0.5em 0em 2em 0em"
                                                    fontSize="13px"
                                                    disabled={!topicItem.enableButton}
                                                    clicked={topicItem.enableButton && !props.showLiveSessionLoader
                                                        ? () => props.startLiveSession(topicItem.liveSessionId, topicItem.startURL, startedBy)
                                                        : null} />

                                                {
                                                    topicItem.enableButton && !props.showLiveSessionLoader
                                                        ? <Button
                                                            label={'END LIVE SESSION'}
                                                            padding="0.9em 2em"
                                                            styleclass='GoToCourseButton'
                                                            margin="0.5em 0em 2em 1.5em"
                                                            fontSize="13px"
                                                            disabled={!topicItem.enableButton}
                                                            clicked={topicItem.enableButton && !props.showLiveSessionLoader
                                                                ? () => props.endLiveSession(topicItem.liveSessionId)
                                                                : null} />
                                                        : null
                                                }
                                            </>
                                            : <span className={classes.BeginsText}>
                                                This Live session has ended
                                            </span>}
                            </div>
                        </div>
                    );
                    liveSessionsList.push(liveSessionTopic);
                }
            }
            itemCount = updatedTopic !== null ? itemCount += 1 : itemCount;
            return updatedTopic;
        }) : [];

    const allQuizList = !IsObjectEmpty(props.data.todaysPlan) && !IsListEmpty(props.data.todaysPlan.quizList)
        ? props.data.todaysPlan.quizList.map((topicItem, index) => {
            return (
                <p className={classes.PlanEntity} key={index} onClick={() => props.onTodaysPlanTopicClicked(topicItem.topicId)}>
                    Quiz <span>opens at {topicItem.scheduleTime}</span>
                </p>
            )
        }) : null;

    itemCount = allQuizList !== null ? itemCount += 1 : itemCount;

    const allAssignmentList = !IsObjectEmpty(props.data.todaysPlan) && !IsListEmpty(props.data.todaysPlan.assignmentList)
        ? props.data.todaysPlan.assignmentList.map((topicItem, index) => {
            return (
                <p className={classes.PlanEntity} key={index} onClick={() => props.onTodaysPlanTopicClicked(topicItem.topicId)}>
                    Assignment <span>opens at {topicItem.scheduleTime}</span>
                </p>
            )
        }) : null;

    itemCount = allAssignmentList !== null ? itemCount += 1 : itemCount;

    return (
        <>
            <div className={classes.TodaysPlanCardContainer}>
                <div className={classes.TodaysPlanCard}>
                    <div className={classes.ModuleDetails}>
                        <div className={classes.ModuleMetaData}>
                            <img className={classes.ModuleLogo} src={props.data.module.logo} alt="module logo" />
                            <div>
                                <h4 className={classes.ModuleName}>{props.data.module.name}</h4>
                                <div className={classes.ProfilePicContainer}>
                                    <img className={classes.InstructorProfilePic} src={props.data.instructor.profilePic} alt="module instructor profile pic" />
                                    <p className={classes.InstructorName}>{props.data.instructor.name}</p>
                                </div>
                            </div>
                        </div>
                        {
                            !IsListEmpty(liveSessionsList)
                                ? liveSessionsList
                                : <p className={classes.NoTopicsText}>No topics are scheduled for today.</p>
                        }
                    </div>
                    <div className={classes.TodaysPlan}>
                        <h4 className={classes.PlanHeading}>Today's Plan</h4>
                        <span className={classes.PlanDate}>{props.data.todaysPlan.date}</span>

                        {allTopicsList}

                        {allQuizList}

                        {allAssignmentList}

                        {
                            itemCount === 0
                                ? <p className={classes.NoTopicsText}>No topics are scheduled for today.</p>
                                : null
                        }

                    </div>
                </div>
            </div>
        </>
    );
}

export default TodaysPlanCard;